/* ==========================================================================
   vd-custom.js
   VitaDrip — B2B research-supplier theme behaviours for Shopify Dawn (OS 2.0)
   Vanilla JS, no dependencies. Safe to load in <head> with `defer`.
   Handles: FAQ accordion, COA library search/filter, B2B order-request
   confirmation gating (disables checkout until research-use box is ticked).
   ========================================================================== */
(function () {
  'use strict';

  function once(el) {
    if (!el || el.dataset.vdInit === '1') return false;
    el.dataset.vdInit = '1';
    return true;
  }

  /* ---- 1. FAQ accordion -------------------------------------------------- */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-vd-faq]').forEach(function (faq) {
      if (!once(faq)) return;
      faq.querySelectorAll('.vd-faq__item').forEach(function (item) {
        var btn = item.querySelector('.vd-faq__q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = item.getAttribute('aria-expanded') === 'true';
          // optional single-open behaviour
          if (faq.hasAttribute('data-vd-faq-single') && !open) {
            faq.querySelectorAll('.vd-faq__item[aria-expanded="true"]').forEach(function (other) {
              other.setAttribute('aria-expanded', 'false');
              var ob = other.querySelector('.vd-faq__q');
              if (ob) ob.setAttribute('aria-expanded', 'false');
            });
          }
          item.setAttribute('aria-expanded', open ? 'false' : 'true');
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* ---- 2. COA library search / filter ------------------------------------ */
  function initCoaSearch(root) {
    (root || document).querySelectorAll('[data-vd-coa]').forEach(function (lib) {
      if (!once(lib)) return;
      var input = lib.querySelector('[data-vd-coa-search]');
      var statusSel = lib.querySelector('[data-vd-coa-status]');
      var grid = lib.querySelector('[data-vd-coa-grid]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-vd-coa-card]'));
      var empty = lib.querySelector('[data-vd-coa-empty]');

      function apply() {
        var q = (input && input.value || '').trim().toLowerCase();
        var status = (statusSel && statusSel.value || '').toLowerCase();
        var shown = 0;
        cards.forEach(function (card) {
          var hay = (card.getAttribute('data-vd-coa-text') || '').toLowerCase();
          var cardStatus = (card.getAttribute('data-vd-coa-cardstatus') || '').toLowerCase();
          var matchText = !q || hay.indexOf(q) !== -1;
          var matchStatus = !status || cardStatus === status;
          var show = matchText && matchStatus;
          card.hidden = !show;
          if (show) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
      }

      if (input) input.addEventListener('input', apply);
      if (statusSel) statusSel.addEventListener('change', apply);
      apply();
    });
  }

  /* ---- 3. B2B order-request confirmation gate ---------------------------- */
  /* Disables the checkout/submit button until the research-use confirmation
     checkbox is ticked. Works with Dawn's cart form and cart drawer.        */
  function initOrderConfirm(root) {
    (root || document).querySelectorAll('[data-vd-confirm]').forEach(function (box) {
      if (!once(box)) return;
      // data-vd-confirm="document" gates checkout controls anywhere on the page
      // (Dawn's checkout button sits in its own cart form). Otherwise gate within
      // the checkbox's own form.
      var scope = box.getAttribute('data-vd-confirm') === 'document'
        ? document
        : (box.closest('form') || document);
      var targets = scope.querySelectorAll('[data-vd-requires-confirm], [name="checkout"], button[name="checkout"]');
      function sync() {
        targets.forEach(function (t) {
          t.disabled = !box.checked;
          t.setAttribute('aria-disabled', box.checked ? 'false' : 'true');
        });
      }
      box.addEventListener('change', sync);
      sync();
    });
  }

  /* ---- 4. Scroll reveal (fade/translate in on view) ---------------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.vd-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { if (el.dataset.vdRev === '1') return; el.dataset.vdRev = '1'; io.observe(el); });
    // safety net: never leave content hidden if the observer misfires
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-visible'); }); }, 1400);
  }

  /* ---- 5. Count-up for stat numbers (data-vd-count="1200") --------------- */
  function initCountUp(root) {
    var nums = (root || document).querySelectorAll('[data-vd-count]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, target = parseFloat(el.getAttribute('data-vd-count')) || 0;
        var suffix = el.getAttribute('data-vd-suffix') || '', steps = 36, i = 0;
        var timer = setInterval(function () {
          i++; var v = Math.round(target * (i / steps));
          el.textContent = v.toLocaleString() + suffix;
          if (i >= steps) { el.textContent = target.toLocaleString() + suffix; clearInterval(timer); }
        }, 22);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (el) { if (el.dataset.vdCnt === '1') return; el.dataset.vdCnt = '1'; io.observe(el); });
  }

  /* ---- 6. Collection filter pills ---------------------------------------- */
  function initCollFilter(root) {
    (root || document).querySelectorAll('[data-vd-collection]').forEach(function (coll) {
      if (coll.dataset.vdColl === '1') return; coll.dataset.vdColl = '1';
      var pills = Array.prototype.slice.call(coll.querySelectorAll('[data-vd-filter-pills] [data-vd-filter]'));
      var grid = coll.querySelector('[data-vd-grid]');
      var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-vd-card]')) : [];
      var empty = coll.querySelector('[data-vd-grid-empty]');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var f = pill.getAttribute('data-vd-filter');
          pills.forEach(function (p) { var on = p === pill; p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          var shown = 0;
          cards.forEach(function (c) { var show = f === 'all' || c.getAttribute('data-type') === f; c.hidden = !show; if (show) shown++; });
          if (empty) empty.hidden = shown !== 0;
        });
      });
    });
  }

  /* ---- 7. Collection sort dropdown --------------------------------------- */
  function initCollSort(root) {
    (root || document).querySelectorAll('[data-vd-sort]').forEach(function (sel) {
      if (sel.dataset.vdSort === '1') return; sel.dataset.vdSort = '1';
      sel.addEventListener('change', function () {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sel.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        } catch (e) { window.location.search = '?sort_by=' + encodeURIComponent(sel.value); }
      });
    });
  }

  /* ---- Boot -------------------------------------------------------------- */
  function boot(root) {
    initFaq(root);
    initCoaSearch(root);
    initOrderConfirm(root);
    initReveal(root);
    initCountUp(root);
    initCollFilter(root);
    initCollSort(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Re-init for sections re-rendered by the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  // Expose for manual re-init if needed.
  window.VDTheme = { boot: boot };
})();
